import React from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";

const SessionExpiredModal = ({ open, onConfirm }) => {
    return (
        <Dialog open={open} disableEscapeKeyDown disableBackdropClick maxWidth="xs" fullWidth aria-labelledby="session-expired-dialog">
            <DialogContent style={{ padding: "24px", textAlign: "center" }}>
                <div style={{ marginBottom: "16px" }}>
                    <img src="/images/icons/session-expired.png" alt="Session Expired" style={{ width: "80px", height: "80px" }} />
                </div>
                <h3 style={{ margin: "8px 0", fontSize: "20px", fontWeight: 500 }}>Session Expired</h3>
                <p style={{ color: "#666", fontSize: "14px", margin: "8px 0" }}>Your session has expired. Please login again.</p>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center", padding: "0 24px 24px" }}>
                <Button onClick={onConfirm} variant="contained" color="primary" style={{ textTransform: "capitalize", minWidth: "100px" }}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredModal;
